import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import {
  CellRendererComponent
} from '@valg-shared/components/table/directives/cell-component-outlet/cell-component-outlet.directive';
import { getValueAt } from "@valg-shared/utils/object-utils";
import { Column } from "../../table/column";
import { DateTimeService } from "@valg-shared/services/date-time-service/date-time.service";
import { formatNullableNumberWithDotSeparator } from "@valg-shared/utils/string-utils";
@Component({
  selector: 'valg-number-format-with-dot-renderer',
  templateUrl: './number-format-with-dot-renderer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NumberFormatWithDotRendererComponent implements CellRendererComponent {
  value?: string;

  constructor(
    public readonly dateTimeService: DateTimeService,
    private readonly cdr: ChangeDetectorRef
  ) {
    cdr.detach();
  }

  public init(data: unknown, column: Column): void {
    const defaultValue = (column.metadata)?.defaultValue ?? "0";
    
    const value = getValueAt(data, column.path)
    this.value = value == 0 ? "0" : (formatNullableNumberWithDotSeparator(value) ?? defaultValue);
    this.cdr.detectChanges();
  }
}
